export interface ProductItem {
  productName: string;
  productHeading: string;
  productFavicon: string;
  productId: string;
  productFragment: string;
}

export const productItemsData: ProductItem[] = [
  {
    productName: 'products_page.products.traffic_analytics',
    productHeading: 'products_page.traffic_analytics.productHeading',
    productFavicon: 'TrafficA.svg',
    productId: '1',
    productFragment: 'traffic-analytics',
  },
  {
    productName: 'products_page.products.queue_occupancy',
    productHeading: 'products_page.queue_occupancy.productHeading',
    productFavicon: 'QueueM.svg',
    productId: '2',
    productFragment: 'queue-management',
  },
  {
    productName: 'products_page.products.journey_analytics',
    productHeading: 'products_page.journey_analytics.productHeading',
    productFavicon: 'JourneyA.svg',
    productId: '4',
    productFragment: 'journey-analytics',
  },
];
